angular.module('lsnBase.filters')
  .filter('cutMultiSpaces', [function() {
    return function(value) {
      if (angular.isString(value)) {
        return value.replace(/ +(?= )/g, '').trim();
      } else {
        return value;
      }
    };
  }]);